import React from "react";
import {
  Users,
  Clock,
  FlaskConical,
  Mail,
  LayoutDashboard,
  CalendarClock,
  FileDown,
  Calculator,
} from "lucide-react";
import Reveal from "./Reveal";

// SEZIONE 4 — "Tutto quello che Forfy fa per te"
const FEATURES = [
  { Icon: Users, title: "Anagrafica clienti", desc: "I tuoi clienti e tutto il loro storico, sempre a portata." },
  { Icon: Clock, title: "Timesheet", desc: "Traccia le ore e scopri quanto vale davvero il tuo tempo." },
  { Icon: FlaskConical, title: "Simulazioni", desc: "“Cosa succede se fatturo X?” Forfy te lo dice prima." },
  { Icon: Mail, title: "Solleciti automatici", desc: "Le fatture scadute si fanno pagare da sole." },
  { Icon: LayoutDashboard, title: "Dashboard KPI", desc: "Fatturato, netto e tasse in un colpo d'occhio." },
  { Icon: CalendarClock, title: "Scadenze fiscali", desc: "Mai più una data dimenticata." },
  { Icon: FileDown, title: "Export commercialista", desc: "Dati ordinati e pronti da condividere." },
  { Icon: Calculator, title: "Calcolo INPS e aliquota", desc: "5% o 15%, Forfy applica quella giusta in automatico." },
];

export default function FeatureGrid() {
  return (
    <section className="features" id="funzionalita">
      <div className="container">
        <div className="section-heading section-heading--center">
          <Reveal as="p" className="section-label">
            Tutto in un posto
          </Reveal>
          <Reveal as="h2" className="section-title" delay={60}>
            Tutto quello che Forfy fa per te.
          </Reveal>
          <Reveal as="p" className="section-subtitle" delay={120}>
            Una sola piattaforma, al posto di dieci fogli Excel.
          </Reveal>
        </div>

        <div className="feature-grid">
          {FEATURES.map(({ Icon, title, desc }, i) => (
            <Reveal key={title} className="feature-card" delay={(i % 4) * 60}>
              <span className="feature-emoji" aria-hidden="true">
                <Icon size={28} strokeWidth={1.5} color="#FF8A5C" />
              </span>
              <h3>{title}</h3>
              <p>{desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
